import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import styles from '../shared/styles';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { DivisionLabel } from '../shared/styled-components';
import { DraftEditorWrapper } from '../../../../styles/styled';

const Description = (props) => {
  const {
    value,
    placeholder,
    onChange,
  } = props;

  return (
    <div className="row" style={styles.rowDivision}>
      <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <DivisionLabel>
          Description
        </DivisionLabel>
        <DraftEditorWrapper>
          <Editor
            placeholder={placeholder}
            editorState={value}
            editorStyle={styles.editorStyle}
            onEditorStateChange={onChange}
            stripPastedStyles={true}
            toolbar={{
              embedded: {
                component: () => null,
              },
            }}
          />
        </DraftEditorWrapper>
      </div>
    </div>
  );
};

Description.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

Description.defaultProps = {
  value: {},
  placeholder: '',
  onChange: () => {},
};

export default Description;